import { getNavigationCardItems } from "lib/utils";
import NavigationCards from "components/navigation/navigation-cards/navigation-cards";
import { useContext, useMemo } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import NavigationCards2 from "components/navigation/navigation-cards/navigation-cards2";


export default function StorageReportsIndex() {

  const location = useLocation();

  return (
    <NavigationCards2 route={location.pathname} />
  );
}
